<template>
	<div class="single-choice">
		<strong class="single-choice__lead">{{ lead }}</strong>
		<div class="single-choice__description">{{ description }}</div>
		<div class="single-choice__options">
			<label
				:class="{
					'single-choice__option-tile': true,
					'single-choice__option-tile--chosen': choice === option.value,
				}"
				:for="`${prop}-${i}`"
				v-for="(option, i) in options"
				:key="option.text"
			>
				{{ option.text }}
				<div :class="{radio: true, 'radio--checked': option.value === choice}">
					<label class="radio__container radio__container--physician-table">
						<input
							:id="`${prop}-${i}`"
							:value="option.value"
							type="radio"
							:name="prop"
							v-model="choice"
							class="radio__input"
						/>
						<span
							:class="[
								'radio__checkmark',
								'radio__checkmark--radio',
								'radio__checkmark--physician-table',
								{'--checked': option.value === choice},
							]"
						></span>
					</label>
				</div>
			</label>
		</div>
	</div>
</template>

<script>
export default {
	name: 'SingleChoice',
	props: {
		prop: {
			type: String,
			required: true,
		},
		propSetter: {
			type: String,
			required: true,
		},
		lead: {
			type: String,
			required: true,
		},
		description: {
			type: String,
			required: true,
		},
		options: {
			type: Array,
			required: true,
		},
	},
	computed: {
		choice: {
			get() {
				return this.$store.getters['unitConfiguration/data'](this.prop).name;
			},
			set(newValue) {
				this.$store.commit('unitConfiguration/' + this.propSetter, newValue);
			},
		},
	},
};
</script>
